import { FC, useCallback } from 'react';
import { Button, ButtonSize } from '@lemon8/design';
import { useTranslation } from 'react-i18next';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ModuleType } from '~/utils/module-type';
import { ClickPosition } from '~/utils/click-position';
import useReflowClick from '~/utils/use-reflow-click';
import { usePageActive } from '~/utils/active/use-page-active';

import './style.scss';

interface IGalleryImgMaskProps {
  groupId: string;
}

export const GalleryImgMask: FC<IGalleryImgMaskProps> = (props) => {
  const { groupId } = props;

  const active = usePageActive();

  const { t } = useTranslation();

  const openBtnObservedRef = useViewTracking({
    onView: useCallback(() => {
      window.Tea('wap_module_show', {
        current_page_module: ModuleType.gallery_img_mask,
        group_id: groupId,
      });
      window.Tea('wap_cta_show', {
        current_page_module: ModuleType.gallery_img_mask,
        current_position: ClickPosition.gallery_img_mask_open_btn,
        group_id: groupId,
      });
    }, []),
  });

  const handleOpenBtnClick = useReflowClick(
    {
      clickEvent: (_, bundle) => ({
        ...bundle,
        current_position: ClickPosition.gallery_img_mask_open_btn,
      }),
      reflowBehavior: () => {
        active({
          schemaOption: {
            pageType: 'article',
            groupId,
          },
          ampExtra: {
            enter_position: ClickPosition.gallery_img_mask_open_btn,
          },
        });
      },
      defaultBehavior: (e) => {
        e?.stopPropagation();
      },
    },
    [active],
  );

  return (
    <div className="gallery-img-mask">
      <div className="gallery-img-mask-main">
        <div className="gallery-img-mask-main-title">{t('seo_photoPost_modal_title')}</div>
        <div className="active-btn" ref={openBtnObservedRef}>
          <Button
            variant="Primary"
            size={ButtonSize.large}
            onClick={handleOpenBtnClick}
            title={t('seo_photoPost_modal_btn_openApp')}
          />
        </div>
      </div>
    </div>
  );
};
